"use client";

import Link from "next/link";

import { AdAwareSingleCtaButton } from "@/components/AdAwareButtons";
import { NewButton } from "@/components/ui/NewButton";
import { useIsAdLanding } from "@/lib/hooks/useIsAdLanding";

export function HomeVideoSectionButtons({ registerUrl }: { registerUrl: string }) {
  const isAdLanding = useIsAdLanding();

  if (isAdLanding) {
    return (
      <div className="flex flex-col items-center md:flex-row gap-4 justify-center mt-[64px]">
        <Link href="/book-a-demo" target="_self" data-mixpanel-id="other-book-a-demo">
          <NewButton variant="primary" size="md" arrow="grow" asChild className="px-8 w-[195px]">
            Book a Demo
          </NewButton>
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center md:flex-row gap-4 justify-center mt-[64px]">
      <Link href="/book-a-demo" target="_self" data-mixpanel-id="other-book-a-demo">
        <NewButton variant="primary" size="md" arrow="grow" asChild className="px-8 w-[195px]">
          Book a Demo
        </NewButton>
      </Link>
      <AdAwareSingleCtaButton
        defaultHref={registerUrl}
        defaultText="Start Free Trial"
        adHref="/book-a-demo"
        adText="Book a demo"
        variant="outlinePrimary"
        size="md"
        className="w-[221px]"
        arrow="hover"
        arrowColorClass="stroke-primary"
        disclaimer={undefined}
        mixpanelId="other-start-free-trial"
        targetExternal="_blank"
      />
    </div>
  );
}
